import styled from 'styled-components/macro';
import { SecondPart } from '../../interfaces/buildings';
import { createRef } from 'react';
import { HotspotConfig } from '../../config/city';
import { getOffsetPosition } from '../utils/position';
import { useStore } from '../store';
import { useHistory } from 'react-router-dom';
import theme from '../../config/theme';
import { KeepScale } from 'react-zoom-pan-pinch';

const StyledArrow = styled(KeepScale)<{ left: string; top: string; direction: number; color?: string }>`
    position: absolute;
    top: ${(props) => props.top};
    left: ${(props) => props.left};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${(props) => props.color || theme.colors.primary80};

    &:before {
        content: '';
        display: block;
        width: 10px;
        aspect-ratio: 1/1;
        background: ${(props) => props.color || theme.colors.white};
        clip-path: polygon(0% 45%, 80% 45%, 45% 0%, 60% 0%, 100% 50%, 60% 100%, 45% 100%, 80% 55%, 0% 55%);
        ${(props) => 'transform: rotate(' + props.direction + 'deg);'}
        margin-left: 10px;
    }
`;

const ArrowText = styled.p`
    margin: 4px 10px;
    color: ${theme.colors.white};
    font-size: ${theme.typography.md};
    font-weight: bold;
`;

const SecondPartArrow = ({
    direction,
    config,
    text
}: SecondPart) => {
    const { state } = useStore();
    const history = useHistory();
    const containerRef = createRef<HTMLDivElement>();

    const handleHotspotClick = (config: HotspotConfig, pos: {left: string, top: string}) => {
        if (config.type !== 'inactive') {
            openBuilding(config.link || config.building, `${pos.left} ${pos.top}`)
        }
    }
    const openBuilding = (path: string, coords: string) => {
        if (containerRef.current) {
            containerRef.current.style.transformOrigin = coords;
        }
        history.push(`/${path}`);
    };

    const pos = getOffsetPosition({
        ...config.coordinates,
        imgWidth: state.appDimensions.width,
        imgHeight: state.appDimensions.height,
    })

    let arrowDirection;
    switch (direction) {
        case 'Up':
            arrowDirection = -90;
            break;
        case 'Down':
            arrowDirection = 90;
            break;
        case 'Left':
            arrowDirection = 0;
            break;
        case 'Right':
            arrowDirection = 180;
            break;
    }

    return (
        <StyledArrow
            direction={arrowDirection}
            left={pos.left}
            top={pos.top}
            onClick={() => handleHotspotClick(config, pos)}
        >
            <ArrowText>{text}</ArrowText>
        </StyledArrow>
    );
};

export default SecondPartArrow;
